export default {
  maxCharacterErrorMessage: _ref => {
    let {
      counterMax,
      label
    } = _ref;
    return `Enter maximum of ${counterMax} characters for ${label}.`;
  },
  optional: "optional",
  overLimitMessage: "characters over limit",
  requiredErrorMessage: label => `Enter ${label}`
};